import { throttle, isTablet } from './../../../helper-functions'
import scrolldir from 'scrolldir'

/*eslint max-statements: ["error", 50]*/
/*eslint-env es6*/

/**
 * Function that toggles the header menu.
 */
export default function stickyNav () {
  const header = document.querySelector( '.js-header' )

  if ( !header ) {
    return
  }

  /*******************************************************************************************
   * DOM reading
   *******************************************************************************************/
  const headerStyle = header.dataset.headerStyle
  const menuContainer = header.querySelector( '.js-menu-container' )
  const logoWhite = header.querySelector( '.js-logo-white' )
  const logoColor = header.querySelector( '.js-logo-color' )
  const mainMenuWhite = header.querySelector( '.js-main-menu-white' )
  const mainMenuDark = header.querySelector( '.js-main-menu-dark' )
  const topMenuWhite = header.querySelector( '.js-top-menu-white' )
  const topMenuDark = header.querySelector( '.js-top-menu-dark' )
  const hamburgerLight = header.querySelector( '.js-hamburger-light' )
  const hamburgerDark = header.querySelector( '.js-hamburger-dark' )
  const languageSwitcher = header.querySelector( '.js-language-switcher' )
  const languageSwitcherDark = header.querySelector( '.js-language-switcher-dark' )
  const searchBoxContainer = header.querySelector( '.js-search-autocomplete' )
  const mobileSearchButtonWhite = header.querySelector( '.js-mobile-search-button-white' )
  const mobileSearchButtonDark = header.querySelector( '.js-mobile-search-button-dark' )

  /*******************************************************************************************
   * DOM manipulation
   *******************************************************************************************/

  const transparentBgHeaderStyle = () => header.classList.remove( 'bg-white' )

  const whiteBgHeaderStyle = () => header.classList.add( 'bg-white' )

  const whiteMenuStyle = () => {
    mainMenuWhite.classList.add( 'lg:block' )
    mainMenuWhite.classList.remove( 'lg:hidden' )
    mainMenuDark.classList.add( 'lg:hidden' )
    mainMenuDark.classList.remove( 'lg:block' )
  }

  const blackMenuStyle = () => {
    mainMenuWhite.classList.add( 'lg:hidden' )
    mainMenuWhite.classList.remove( 'lg:block' )
    mainMenuDark.classList.add( 'lg:block' )
    mainMenuDark.classList.remove( 'lg:hidden' )
  }

  const whiteTopMenuStyle = () => {
    topMenuWhite.classList.add( 'lg:block' )
    topMenuWhite.classList.remove( 'lg:hidden' )
    topMenuDark.classList.add( 'lg:hidden' )
    topMenuDark.classList.remove( 'lg:block' )
  }

  const blackTopMenuStyle = () => {
    topMenuWhite.classList.add( 'lg:hidden' )
    topMenuWhite.classList.remove( 'lg:block' )
    topMenuDark.classList.add( 'lg:block' )
    topMenuDark.classList.remove( 'lg:hidden' )
  }

  const blackTextLanguageSwitcherStyle = () => {
    languageSwitcher.classList.add( 'hidden' )
    languageSwitcher.classList.remove( 'block' )
    languageSwitcherDark.classList.add( 'block' )
    languageSwitcherDark.classList.remove( 'hidden' )
  }

  const whiteTextLanguageSwitcherStyle = () => {
    languageSwitcher.classList.add( 'block' )
    languageSwitcher.classList.remove( 'hidden' )
    languageSwitcherDark.classList.add( 'hidden' )
    languageSwitcherDark.classList.remove( 'block' )
  }

  const headerWhiteBordersStyle = () => {
    menuContainer.classList.add( 'border-b-1' )
    menuContainer.classList.remove( 'border-white-.15' )
    menuContainer.classList.add( 'border-black-10' )
  }

  const headerTransparentBordersStyle = () => {
    menuContainer.classList.remove( 'border-b-1' )
    menuContainer.classList.add( 'border-white-.15' )
    menuContainer.classList.remove( 'border-black-10' )
  }

  const whiteLogoStyle = () => {
    logoWhite.classList.remove( 'hidden' )
    logoWhite.classList.add( 'block' )
    logoColor.classList.add( 'hidden' )
    logoColor.classList.remove( 'block' )
  }

  const colorLogoStyle = () => {
    logoWhite.classList.add( 'hidden' )
    logoWhite.classList.remove( 'block' )
    logoColor.classList.remove( 'hidden' )
    logoColor.classList.add( 'block' )
  }

  const blackSearchBoxStyle = () => {
    searchBoxContainer.classList.remove( 'search-form-container--white' )
  }

  const whiteSearchBoxStyle = () => {
    searchBoxContainer.classList.add( 'search-form-container--white' )
  }

  const whiteHamburgerStyle = () => {
    hamburgerLight.classList.add( 'block' )
    hamburgerLight.classList.remove( 'hidden' )
    hamburgerDark.classList.add( 'hidden' )
    hamburgerDark.classList.remove( 'block' )
  }

  const blackHamburgerStyle = () => {
    hamburgerLight.classList.add( 'hidden' )
    hamburgerLight.classList.remove( 'block' )
    hamburgerDark.classList.add( 'block' )
    hamburgerDark.classList.remove( 'hidden' )
  }

  const whiteMobileSearchButtonStyle = () => {
    mobileSearchButtonWhite.classList.add( 'inline-block' )
    mobileSearchButtonWhite.classList.remove( 'hidden' )
    mobileSearchButtonDark.classList.add( 'hidden' )
    mobileSearchButtonDark.classList.remove( 'inline-block' )
  }

  const blackMobileSearchButtonStyle = () => {
    mobileSearchButtonWhite.classList.add( 'hidden' )
    mobileSearchButtonWhite.classList.remove( 'inline-block' )
    mobileSearchButtonDark.classList.add( 'inline-block' )
    mobileSearchButtonDark.classList.remove( 'hidden' )
  }

  const toggleTopHeader = action => header.classList[action]( isTablet() ? 'translate-up-3.3' : 'translate-up-2.5' )

  const contractTopHeader = () => toggleTopHeader( 'add' )

  const expandTopHeader = () => toggleTopHeader( 'remove' )

  const resetStyles = () => {
    mainMenuDark.classList.add( 'hidden', 'lg:block' )
    topMenuDark.classList.add( 'hidden', 'lg:block' )
  }
  /*******************************************************************************************
   * Events
   *******************************************************************************************/
  window.addEventListener( 'scroll', throttle( () => {
    setHeaderStyle()
    // Run the function a last time to ensure the header sets correctly.
    setTimeout( setHeaderStyle, 500 )
  }, 60 ) )

  window.addEventListener( 'orientationchange', resetStyles )

  /******************************************************************************************
   * Init
   *****************************************************************************************/
  /**
   * Init scroll direction library.
   */
  scrolldir({
    el: header,
    dir: 'up'
  })

  /**
   * Set initial header style.
   */
  setHeaderStyle()

  /*******************************************************************************************
   * State
   *******************************************************************************************/
  let scrollDirectionFlag = null

  /*******************************************************************************************
   * Functions
   *******************************************************************************************/
  /**
   * White header style.
   */
  function whiteHeaderStyle() {
    whiteBgHeaderStyle()
    colorLogoStyle()
    blackHamburgerStyle()
    whiteSearchBoxStyle()
    headerWhiteBordersStyle()
    blackTextLanguageSwitcherStyle()
    blackMenuStyle()
    blackTopMenuStyle()
    blackMobileSearchButtonStyle()
  }

  /**
   * Transparent header style.
   */
  function transparentHeaderStyle() {
    transparentBgHeaderStyle()
    whiteLogoStyle()
    whiteHamburgerStyle()
    blackSearchBoxStyle()
    headerTransparentBordersStyle()
    whiteTextLanguageSwitcherStyle()
    whiteMenuStyle()
    whiteTopMenuStyle()
    whiteMobileSearchButtonStyle()
  }

  /**
   * Adds the classes to all elements to create the different menu style when scrolled down.
   *
   * Ref: https://stackoverflow.com/questions/31223341/detecting-scroll-direction
   */
  function setHeaderStyle() {
    const scrollPosition = Math.round( window.pageYOffset || document.documentElement.scrollTop )

    if ( scrollPosition > 50 ) {
      whiteHeaderStyle()

      if ( ( scrollDirectionFlag === null || scrollDirectionFlag === 'up' )
        && 'down' === header.dataset.scrolldir ) {
        // On scroll down.
        scrollDirectionFlag = 'down'
        contractTopHeader()
      } else if ( ( scrollDirectionFlag === null || scrollDirectionFlag === 'down' )
        && 'up' === header.dataset.scrolldir ) {
        // On scroll up.
        scrollDirectionFlag = 'up'
        expandTopHeader()
      }
    } else {
      expandTopHeader()

      if ( 'transparent-bg' === headerStyle ) {
        // Transparent background only on top of the page when there is a Hero.
        transparentHeaderStyle()
      }
    }
  }
}
